<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <potato-field-form-groups
        :submission="submission"
        :index="index"
        @onFieldChange="onFieldChange"
      ></potato-field-form-groups>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <potato-sample-form-group
          v-for="(sample, index) in submission_data.samples"
          :key="index"
          :sample="sample"
          :index="index"
          :sampleListLength="submission_data.samples.length"
          :customer_field_options="customer_field_options"
          @onSampleChange="onSampleChange"
          @onSampleListChange="onSampleListChange"
        ></potato-sample-form-group>
      </div>
      <div>
        <b-row class="mb-3" align-h="end">
          <b-col class="pr-0" cols="2">
            <b-button
              variant="success"
              block
              @click="onSampleListChange({ action: 'add' })"
              ><i class="fa fa-plus"></i> Add</b-button
            >
          </b-col>
          <b-col cols="5">
            <b-input-group append="Sample(s)">
              <b-form-input
                type="number"
                min="1"
                placeholder="New Samples Quantity"
                v-model="new_samples_quantity"
                @change="handleQuantityChange"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </div>
      <div v-if="turnArounds && turnArounds.models.length">
        <hr />
        <turn-around-select
          v-if="turnArounds.models.length"
          :turnArounds="turnArounds"
          :selectedTurnAround="submission_data.turnaround"
          @onTurnAroundSelect="onTurnAroundSelect"
        ></turn-around-select>
      </div>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :key="index"
          :serviceQuestion="serviceQuestion"
        ></service-question>
      </div>
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>
<script>
import PotatoFieldFormGroups from "./PotatoFieldFormGroups";
import PotatoSampleFormGroup from "./PotatoSampleFormGroup";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import TurnAroundSelect from "../../TurnAroundSelect";
import CustomerFieldCollection from '@/collections/crm/CustomerFieldCollection'

export default {
  name: "PotatoForm",
  components: {
    PotatoFieldFormGroups,
    PotatoSampleFormGroup,
    TurnAroundSelect
  },
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    index: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      submission_data: null,
      new_samples_quantity: null,

      selected_customer_grower_id: null,
      customer_fields: new CustomerFieldCollection()
    };
  },
  computed: {
    customer_field_options () {
      return this.customer_fields && this.customer_fields.models && this.customer_fields.models.map((field) => {
        return {
          value: field.id,
          text: field.name
        }
      }) || []
    }
  },
  methods: {
    handleQuantityChange(value) {
      this.new_samples_quantity = value;
    },
    onFieldChange(data) {
      if (data) {
        this.submission_data.submission_potato.grower = data.grower;
        this.submission_data.submission_potato.storage_bin = data.storage_bin;
        this.submission_data.identifier = data.identifier;
        this.submission_data.event_code = data.event_code;

        if (data.customer_grower_id) {
          this.submission_data.submission_potato.customer_grower_id = data.customer_grower_id
          this.selected_customer_grower_id = data.customer_grower_id
        }
        this.emitSubmissionChange();
      }
    },
    onSampleChange(params) {
      if (params) {
        const { sample, index } = params;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onSampleListChange({ action, index }) {
      let sample_list_update = [...this.submission_data.samples];
      switch (action) {
        case "duplicate": {
          const duplicated_sample = { ...sample_list_update[index] };
          sample_list_update.splice(index + 1, 0, {
            ...duplicated_sample,
            identifier: null,
            test_package_sample_id: this.$uuid.v4()
          });
          break;
        }
        case "remove": {
          sample_list_update.splice(index, 1);
          break;
        }
        case "add": {
          if (this.new_samples_quantity) {
            const last_sample = this.submission_data.samples.find(
              (sample, index) =>
                index + 1 === this.submission_data.samples.length
            );
            let counter = 0;
            while (counter < this.new_samples_quantity) {
              counter++;
              sample_list_update = [
                ...sample_list_update,
                {
                  ...last_sample,
                  identifier: null,
                  test_package_sample_id: this.$uuid.v4()
                }
              ];
            }
          }
          break;
        }
        default:
      }
      this.submission_data.samples = [...sample_list_update];
      this.new_samples_quantity = null;
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.submission_data.turnaround_id = turnaround.id;
        this.emitSubmissionChange();
      } else {
        this.submission_data.turnaround = null;
        this.submission_data.turnaround_id = null;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    },
    fetchCustomerField () {
      const collection = new CustomerFieldCollection()
      const filter = collection.getFilter()

      if (this.selected_customer_grower_id) {
        filter.filterEquals('customer.id', this.$store.getters.getAuthCustomerID)
        filter.filterEquals('customer_grower_id', this.selected_customer_grower_id)

        collection.fetch().then(() => {
          this.customer_fields = collection
        })
      } else {
        this.customer_fields = collection
      }
    }
  },
  watch: {
    form: {
      handler() {
        this.emitSubmissionChange();
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    },
    selected_customer_grower_id: {
      handler() {
        this.fetchCustomerField()
      },
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
